<sk-text
  [label]="label() | translate"
  [floatLabel]="'never'"
  [stylingMode]="'unformed'"
  [showClear]="true"
  [formControl]="fieldControl"
  data-test="ag-grid-field-text-floating-filter"
></sk-text>
